import React, {useState} from 'react'
import {observer} from 'mobx-react'
import ReactPlayer from 'react-player'
import PropTypes from "prop-types";
import Utility from "../../../../Utility";
import ConditionalComponent from "../../../Shared/ConditionalComponent";
import './procedureMedia.scss';
import {useStores} from "../../../../Hooks";

const DisplayVideo = observer(props => {
    const {procedureStore} = useStores();
    const {id} = props;
    const autoPlay = procedureStore.currentProcedure?.Settings?.VideoAutoPlay;
    const [playing, setPlaying] = useState(!!autoPlay);
    const [showControls, setShowControls] = useState(false);
    let volume = procedureStore.volume / 10;
    if (isNaN(volume)) {
        volume = 5;
    }
    return (
        <div
            className="video-wrapper"
            style={{ maxHeight: '50dvh', maxWidth: '80dvw', width: 'fit-content', background: 'linear-gradient(to bottom, #3a3a3a 33%, #000000 100%)'}}
            onMouseEnter={() => setShowControls(true)}
            onMouseLeave={() => setShowControls(false)}
            onClick={() => {
                if (Utility.isMobile()) {
                    setShowControls(true);
                    Utility.sleep(4000).then(() => setShowControls(false))
                }
            }}
        >
            <ReactPlayer
                config={{file: {attributes: {controlsList: 'nodownload'}}}}
                onContextMenu={e => e.preventDefault()}
                url={id}
                onPlay={() => setPlaying(true)}
                onPause={() => setPlaying(false)}
                playing={playing}
                controls={showControls}
                volume={volume}
                muted={procedureStore.mute}
                height="auto"
                width="auto"
                style={{ maxHeight: '50dvh', maxWidth: '80dvw' }}
            />
            <ConditionalComponent if={!playing}>
                <div className="play-btn" onClick={() => setPlaying(true)}>
                    <i className="fas fa-play-circle"/>
                </div>
            </ConditionalComponent>
        </div>
    )
});

DisplayVideo.propTypes = {
    id: PropTypes.string.isRequired
};

export default DisplayVideo
